module.exports = __webpack_public_path__ + "assets/b54.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b54.png
// module id = 643
// module chunks = 0